<template>
  <v-app>
    <template v-if="$route.path === '/login'">
      <LoginPage />
    </template>
    <template v-else>
      <HeaderView/>
      <v-main class="bg-grey-lighten-3" style="max-height:100vh; height:100%; background-color: white !important;">
        <v-container style="height:100%;" class="custom-container">
          <router-view class="center"/>
        </v-container>
      </v-main>
    </template>
  </v-app>
</template>

<script>
import { useRoute } from 'vue-router'
import HeaderView from './components/HeaderView.vue'
import LoginPage from './views/LoginView.vue' // 실제 로그인 컴포넌트 경로에 맞게 수정
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'mainPageDesign',
  setup() {
    const route = useRoute()
    if (route.path === '/login') {
      // /login 라우트에 있음
    }
  },
  components: {
    HeaderView,
    LoginPage,
  },
  mounted() {
  }
})
</script>

<style lang="css" scoped>
  .custom-container {
    max-width: 1600px !important;
    min-width: 1600px !important;
    height:100%;

  }
</style>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;700&display=swap');

  .v-application {
    font-family: 'Noto Sans KR', sans-serif !important;
  }
</style>
